import { routeConfig } from './routes.js'

export const MAX_PRESERVED_ROUTES = 6

function path_pattern(path) {
  const segments = path.split('/').map((segment) => (
    segment.startsWith(':') ? '[^/]+' : segment.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
  ))
  return new RegExp(`^${segments.join('/')}$`)
}

const preserved_patterns = routeConfig
  .filter((config) => config.meta.preserve)
  .map((config) => path_pattern(config.path))

export function should_preserve_route(path) {
  return preserved_patterns.some((pattern) => pattern.test(path))
}

export function retain_route(pages, current, limit = MAX_PRESERVED_ROUTES) {
  return [...pages.filter((page) => page.key !== current.key), current].slice(-limit)
}
